<template>
	<ul v-if="data" class="g-timeline">
		<li v-for="(item, i) in data" :key="i" class="item">
			<span class="date">{{item.date}}</span>
			<p>{{item.content}}</p>
			<div v-if="item.reject" class="reject">{{item.reject}}</div>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			data: [Array, String, Number]
		}
	}
</script>

<style lang="stylus" scoped>
	.g-timeline {
		padding: 0 .24rem .24rem .35rem;
		
		li {
			position: relative;
			border-left: 1px solid #eee;
			padding: .2rem 0 3px 20px;
			
			&:nth-last-child(1) {
				&:before {
					border-color: #1492FF;
				}
			}
			
			&:before {
				content: '';
				position: absolute;
				left: -.12rem;
				top: .31rem;
				box-sizing: border-box;
				width: .24rem;
				height: .24rem;
				border: .04rem solid #ddd;
				border-radius: 100%;
				background: #fff;
			}
			
			.date {
				display: block;
				margin-right: 20px;
				line-height: .5rem;
				font-size: .26rem;
				white-space: nowrap;
				color: #999;
				
				elder({
					font-size: .36rem
				})
			}
			
			p {
				line-height: .5rem;
				font-size: .3rem;
				color: #000;
				
				elder({
					line-height: .6rem,
					font-size: .4rem
				})
			}
			
			.reject {
				padding: 10px 12px;
				line-height: 24px;
				font-size: 15px;
				color: #E63633;
				background: #FAFAFA;
			}
		}
	}
</style>
